import { functions } from '@/plugins/firebase';
import moment from 'moment';
import _ from 'lodash';

export default {
  namespaced: true,
  state: {
    initialized: false,
    customer: {},
    purchaseHistory: [],
    allHistoryLoaded: false
  },
  mutations: {
    loadCustomer(state, customer) {
      state.customer = customer;
    },
    loadPurchaseHistory(state, payload) {
      // TODO: can't update array
      state.purchaseHistory = payload.purchaseHistory;
      state.allHistoryLoaded = payload.allHistoryLoaded;
    },
    addPaymentMethod(state, card) {
      state.customer.cards.data.unshift(card);
    },
    deletePaymentMethod(state, cardId) {
      const el = _.find(state.customer.cards.data, function (card) {
        return card['id'] == cardId;
      });
      const index = _.indexOf(state.customer.cards.data, el);
      state.customer.cards.data.splice(index, 1);
    }
  },
  actions: {
    async loadCustomer({ commit }, payload) {
      const getCustomerByCustomerId = functions.httpsCallable(
        'paymentGetCustomerByCustomerId'
      );
      let customer = null;
      try {
        customer = await getCustomerByCustomerId({
          customerId: payload.userId
        });
      } catch (err) {
        console.log(err);
      }

      // if customer not exist create one0
      if (!customer) {
        const createCustomer = functions.httpsCallable('paymentCreateCustomer');
        customer = await createCustomer({
          userId: payload.userId,
          email: payload.email
        });
      }
      commit('loadCustomer', customer.data);
    },
    async loadPurchaseHistory({ commit, state }, payload) {
      const getChargeListMethod = functions.httpsCallable(
        'paymentGetChargeList'
      );

      try {
        const purchaseHistory = await getChargeListMethod({
          userId: payload.userId,
          offset: payload.offset
        });
        commit('loadPurchaseHistory', {
          purchaseHistory: state.purchaseHistory.concat(
            purchaseHistory.data.data
          ),
          allHistoryLoaded: purchaseHistory.data.count != 10
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async addPaymentMethod({ commit }, payload) {
      const createPaymentMethod = functions.httpsCallable(
        'paymentCreatePaymentMethod'
      );
      try {
        const card = await createPaymentMethod({
          userId: payload.userId,
          number: payload.number,
          cvc: payload.cvc,
          expMonth: payload.expMonth,
          expYear: payload.expYear
        });
        commit('addPaymentMethod', card.data);
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async deletePaymentMethod({ commit }, payload) {
      const deletePaymentMethod = functions.httpsCallable(
        'paymentDeletePaymentMethod'
      );
      try {
        await deletePaymentMethod({
          userId: payload.userId,
          cardId: payload.cardId
        });
        commit('deletePaymentMethod', payload.cardId);
      } catch (err) {
        console.error(err);
        return;
      }
    }
  },
  getters: {
    paymentMethods(state) {
      return Object.keys(state.customer).length == 0
        ? []
        : state.customer.cards.data;
    },
    paymentHistory(state) {
      return _.map(state.purchaseHistory, function (purchase) {
        return {
          id: purchase.id,
          activity: 'ドロン',
          datetime: moment.unix(purchase.captured_at),
          price: purchase.amount,
          transactionDetails: {
            product: 'ドロン',
            amount: purchase.amount,
            paymentMethod: {
              cardBrand: purchase.card.brand,
              lastFourDigits: purchase.card.last4
            }
          }
        };
      });
    },
    allHistoryLoaded(state) {
      return state.allHistoryLoaded;
    }
  }
};
